'use client';

import { Content } from '@prismicio/client';
import type { Simplify } from '../../../../../prismicio-types';
import { Button, Container } from '@/components';
import { HeroList, Subtitle, Title } from '../../components';
import { useVisible } from '@/hooks';

import styles from './ourProcessHero.module.scss';
import { OurProcessHeroCards } from './OurProcessHeroCards/OurProcessHeroCards';

interface OurProcessHeroProps {
  data: Simplify<Content.HeroSliceOurProcessPrimary>;
}

export const OurProcessHero = ({ data }: OurProcessHeroProps) => {
  const [isVisible, id] = useVisible();

  return (
    <Container id={id} styles={styles.container}>
      <article className={styles.text_wrapper}>
        <Title text={data.title} isVisible={isVisible} />
        <Subtitle
          subtitle={data.subtitle}
          isVisible={isVisible}
          styles={styles.subtitle}
        />
        <HeroList list={data.advantages} isVisible={isVisible} />
        <div
          className={`${styles.button_wrapper} ${isVisible ? styles.isVisible : ''}`}
        >
          <Button
            isArrow
            variation="primary"
            text={data.button_text}
            link={data.button_link}
          />
        </div>
      </article>
      <OurProcessHeroCards data={data} isVisible={isVisible} />
    </Container>
  );
};
